export function emptyArrayToUndefined<T>(array: T[] | undefined): T[] | undefined {
	return array?.length ? array : undefined;
}
